import { defineComponent as o, openBlock as r, createElementBlock as t, normalizeClass as s, renderSlot as a } from "vue";
import { _ as d } from "../../../_plugin-vue_export-helper-dad06003.js";
const n = o({
  name: "VCard",
  props: {
    showsHover: {
      type: Boolean,
      default: !1
    }
  }
});
function l(e, c, i, p, w, f) {
  return r(), t("div", {
    class: s(["hobi-card tw-bg-white tw-border-2 tw-border-solid tw-border-white tw-rounded tw-shadow-md", { "hobi-card--hover hover:tw-border-gray-300": e.showsHover }])
  }, [
    a(e.$slots, "default")
  ], 2);
}
const b = /* @__PURE__ */ d(n, [["render", l]]);
export {
  b as default
};
